import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { estEnCoursDeChargement } from '../../App_Code/Utils';
import { RoutesGenerales, RoutesCopRattachee } from '../../App_Data/Routes';
import Header from './Header';
import BreadCrumb from './BreadCrumb';

const NoMatch = ({ location }) => {
    swal({
        type: 'error',
        title: 'Oups...',
        text: "Le chemin demandé n'existe pas.",
        footer: `Vérifiez que ${location.pathname} existe.`,
    });

    return <Redirect to="/" />;
};

class App extends Component {
    constructor(props) {
        super(props);

        const { Adh, history } = props;
        this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
        this.handleLocationChange(history.location);

        if (estEnCoursDeChargement(Adh)) {
            /* Le store n'est pas initialisé */
            const token = sessionStorage.getItem('token') !== null;
            const droit = sessionStorage.getItem('droit') !== null;
            const premiere = sessionStorage.getItem('premiereCopro') !== null;
            const tokensPresents = (token && droit) || (token && premiere);

            /* Si un des tokens est absent, il vaut mieux tous les supprimer pour éviter des bugs */
            if (!tokensPresents) sessionStorage.clear();

            /* Si les tokens sont présents, un chargement suffit
            Sinon, il faut que l'utilisateur se connecte */
         /*  this.redirection = tokensPresents
                ? { pathname: '/MFA', state: { prevLocation: props.location.pathname } }
                : { pathname: '/Connexion' };*/
           this.redirection = tokensPresents
                ? { pathname: '/Chargement', state: { prevLocation: props.location.pathname } }
                : { pathname: '/Connexion' };
        }
    }

    componentDidMount() {
        document.title = 'Gérer-ma-Copro';
    }

    handleLocationChange = () => {
        window.scrollTo(0, 0);
    };

    render() {
        if (this.redirection) return <Redirect to={this.redirection} />;

        const { Adh } = this.props;
        const CompteNonVide = Adh.LsCopExts.length > 0;
        const RouteDefaut = CompteNonVide ? '/Accueil' : '/AjoutCopro';
        const Routes = CompteNonVide ? RoutesGenerales.concat(RoutesCopRattachee) : RoutesGenerales;
        if (!CompteNonVide) sessionStorage.setItem('premiereCopro', 'true');

        return (
            <div className="App">
                <Header history={this.props.history} CompteNonVide={CompteNonVide} />
                <div className="content-wrapper">
                    <div className="container-fluid">
                        <BreadCrumb {...this.props} />
                        <Switch>
                            <Redirect exact from="/" to={RouteDefaut} />
                            {Routes.map(route => (
                                <Route key={route.path} exact path={route.path} component={route.component} />
                            ))}
                            <Route component={NoMatch} />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ AdhStore: { Adh } }) {
    return { Adh };
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App/index.js